

export default function BarkodePrinter({ appointmentId }) {
    

    return (
        <>
            
        </>
    );
}